import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import { compact, identity } from 'lodash-es';
import head from 'lodash-es/head';
import last from 'lodash-es/last';
import sortBy from 'lodash-es/sortBy';
import moment, { utc } from 'moment';
import { combineLatest, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import {
  gqlMongoByKey,
  gqlMongoDoc,
  gqlMongoLoad,
} from '../../../../shared/classes/loopback-custom-store/generic/store.utils';
import { hAll } from '../../../../shared/classes/utils/utils';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { AuthServiceApi, Consumer, ConsumerApi, LoggerService } from '../../../../shared/sdk';
import { AuthClaimService } from '../../services/auth-claim.service';
import {
  IAuthMember,
  IClaimData,
  INavinetAuthDoc,
  IStediE9yDoc,
  TAppMealClaimSet,
} from '../../services/auth-claim.type';

@Component({
  selector: 'app-dlg-edit-claim',
  templateUrl: './dlg-edit-claim.component.html',
  styleUrls: ['./dlg-edit-claim.component.scss'],
  providers: [AuthClaimService],
})
export class DlgEditClaimComponent extends ABaseComponent implements OnInit {
  claimData: IClaimData;
  auth: INavinetAuthDoc;
  consumer?: Partial<Consumer>;
  e9yDoc?: IStediE9yDoc;
  claimSet?: TAppMealClaimSet;
  navinetClaims?: Record<string, any>[];
  rate: number;
  correctionType: 'new' | 'adjust' | 'void';

  @ViewChild('form', { static: false }) form: DxFormComponent;

  public payerLabel: any;
  public authLabel: any;
  isTest = false;

  constructor(
    protected logger: LoggerService,
    private dss: DataSourceService,
    private ui: UiService,
    private api: AuthServiceApi,
    public config: ConfigService,
    private dialogRef: MatDialogRef<DlgEditClaimComponent, any>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      date: Date;
      member: IAuthMember;
      authId: string;
      cells: { startDate: Date }[];
    },
  ) {
    super(logger);
    // console.log(data);
  }

  ngOnInit() {
    // console.log(this.data);
    this.ui.showLoading();
    void this.buildForm$()
      .toPromise()
      .finally(() => this.ui.hideLoading());
  }

  buildForm$() {
    return combineLatest([this.getAuth$(), this.getConsumer$(), this.getClaimSet$()]).pipe(
      switchMap(([auth, cons, claimSet]) =>
        combineLatest([
          of(null),
          // this.getE9yDoc$(claimSet),
          this.api.getRate(moment(this.data.date).format('YYYY-MM-DD'), oc(auth).Code()),
          this.getNavinetClaims$(auth),
        ]).pipe(map(([e9yDoc, rate, navinetClaims]) => ({ auth, cons, claimSet, e9yDoc, rate, navinetClaims }))),
      ),
      tap(({ auth, cons, claimSet, e9yDoc, rate, navinetClaims }) => {
        this.auth = auth;
        this.consumer = cons;
        // this.e9yDoc = e9yDoc;
        this.claimSet = claimSet;
        this.navinetClaims = navinetClaims;
        this.rate = rate;
      }),
      tap(() => {
        // const memberCl = oc(this.data.member)
        //   .claims([])
        //   .find(cl => cl.auth._id === this.auth._id);

        this.payerLabel =
          'Preselected Payer [' +
          this.mco +
          // || [oc(this.e9yDoc).response.tradingPartnerServiceId(), oc(this.e9yDoc).response.payer.name()].join(' | ')
          ']';

        this.authLabel =
          'Preselected Auth [' +
          [
            oc(this.auth).AuthNumberFacets(),
            utc(oc(this.auth).StartDT()).format('L') + '-' + utc(oc(this.auth).EndDT()).format('L'),
          ].join(' | ') +
          ']';

        const clReq = oc(this.lastClaim).request();
        const clMember = oc(clReq).subscriber();

        const e9yResp = oc(this.e9yDoc).response();
        const e9yMember = oc(e9yResp).subscriber();

        // const anyE9yResp = oc(this.getActiveE9yDocs())[0].response();
        // const anyE9yMember = oc(anyE9yResp).subscriber();

        this.claimData = {
          claimId: oc(this.claimSet)._id(),

          correction: {
            claimControlNumber:
              oc(last(oc(this.navinetClaims)([]))).ClaimID() ||
              oc(last(oc(this.lastClaim)['277ca']([]))).claimStatus.tradingPartnerClaimNumber(),
            // || oc(this.lastClaim).statusClaimID(),
          },

          authId: oc(this.claimSet).auth._id() || oc(this.auth)._id(),

          authID:
            oc(clReq).claimInformation.claimSupplementalInformation.priorAuthorizationNumber() ||
            oc(this.claimSet).auth.AuthNumberFacets() ||
            oc(this.auth).AuthNumberFacets(),

          payerID: oc(clReq).tradingPartnerServiceId() || this.payerId || oc(this.e9yDoc).e9y(),

          procedureCode:
            oc(clReq).claimInformation.serviceLines[0].professionalService.procedureCode() ||
            oc(this.claimSet).auth.Code() ||
            oc(this.auth).Code(),

          rate: this.rate,
          chargeAmount: Number(oc(clReq).claimInformation.claimChargeAmount() || 0),

          subscriber: {
            mci: oc(this.claimSet).auth._mci() || oc(this.auth)._mci() || oc(this.consumer).mci(),
            memberID:
              oc(clMember).memberId() ||
              oc(e9yMember).memberId() ||
              // oc(anyE9yMember).memberId() ||
              oc(this.auth).MemberID(),
            firstname:
              oc(clMember).firstName() ||
              oc(e9yMember).firstName() ||
              // oc(anyE9yMember).firstName() ||
              oc(this.auth).FirstName() ||
              oc(this.consumer).person.firstname(),
            lastname:
              oc(clMember).lastName() ||
              oc(e9yMember).lastName() ||
              // oc(anyE9yMember).lastName() ||
              oc(this.auth).LastName() ||
              oc(this.consumer).person.lastname(),
            gender: oc(clMember).gender() || oc(e9yMember).gender() || (oc(this.consumer).person.sex() as any),
            // || oc(anyE9yMember).gender()
            dob: head(
              compact([
                oc(clMember).dateOfBirth(),
                oc(e9yMember).dateOfBirth(),
                // oc(anyE9yMember).dateOfBirth(),
                oc(this.auth).MemberDOB(),
                oc(this.consumer).person.dob(),
              ]).map(d => moment(d, ['YYYYMMDD', 'YYYY-MM-DD']).format('YYYY-MM-DD')),
            ),
          },

          address: {
            address1:
              oc(e9yMember).address.address1() ||
              // oc(anyE9yMember).address.address1() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].street() ||
              oc(this.consumer).person.contact.addresses[0].street(),
            address2: oc(e9yMember).address.address2(),
            // || oc(anyE9yMember).address.address2()
            city:
              oc(e9yMember).address.city() ||
              // oc(anyE9yMember).address.city() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].city() ||
              oc(this.consumer).person.contact.addresses[0].city(),
            state:
              oc(e9yMember).address.state() ||
              // oc(anyE9yMember).address.state() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].state() ||
              oc(this.consumer).person.contact.addresses[0].state(),
            zip:
              oc(e9yMember).address.postalCode() ||
              // oc(anyE9yMember).address.postalCode() ||
              oc(this.claimSet).consumer.person.contact.addresses[0].zip() ||
              oc(this.consumer).person.contact.addresses[0].zip(),
          },

          service: {
            serviceDate: oc(clReq).claimInformation.serviceLines[0].serviceDate() || head(this.dates),
            serviceDateEnd: oc(clReq).claimInformation.serviceLines[0].serviceDateEnd() || last(this.dates),
            unitCount:
              oc(clReq).claimInformation.serviceLines[0].professionalService.serviceUnitCount() ||
              oc(this.claimSet).meta.authUnits() ||
              oc(this.auth).AuthUnitsApproved() ||
              0,
            chargeAmount: Number(
              oc(clReq).claimInformation.serviceLines[0].professionalService.lineItemChargeAmount() || 0,
            ),
          },
        };
      }),
    );
  }

  get mco() {
    return oc(this.data).member.eligibility.mco();
  }

  get payerId() {
    return {
      'KEYSTONE VIP': '77741',
      KEYSTONE: '42344',
      PHW: '68069',
      UPMC: '23281',
      AMERIHEALTH: '22248',
    }[this.mco];
  }

  get lastClaim() {
    return last(oc(this.claimSet).claimStack([]));
  }

  get dates() {
    const selectedDates = sortBy(
      oc(this.data)
        .cells([])
        .map(c => moment(c.startDate).format('YYYY-MM-DD')),
      identity,
    );

    if (selectedDates.length > 1) return selectedDates;

    const date = moment(this.data.date).format('YYYY-MM-DD');

    const som = utc(date).startOf('month').format('YYYY-MM-DD');
    const eom = utc(date).endOf('month').format('YYYY-MM-DD');

    const asd = this.auth ? utc(this.auth.StartDT).format('YYYY-MM-DD') : undefined;
    const aed = this.auth ? utc(this.auth.EndDT).format('YYYY-MM-DD') : undefined;

    return [last(sortBy(compact([asd, som]), identity)), head(sortBy(compact([aed, eom]), identity))];
  }

  // getActiveE9yDocs() {
  //   return oc(this.data)
  //     .member.e9y([])
  //     .filter(doc => oc(doc).status.active());
  // }

  getConsumer$ = () => {
    const key = oc(this.data).member.c.id();
    return key
      ? this.dss
          .getApi<ConsumerApi>(Consumer)
          .findById<Consumer>(key, { include: [{ person: { contact: ['addresses', 'phones'] } }] }, hAll)
          .pipe(catchError(() => of<null>(null)))
      : of<null>(null);
  };

  getAuth$ = () => {
    const key = oc(this.data).authId();
    return key ? gqlMongoByKey<INavinetAuthDoc>(this.dss, 'ExportsAuthsDataCache', key) : of<null>(null);
  };

  getClaimSet$ = () => {
    const authKey = oc(this.data).authId();
    const yyyymm = Number(moment(this.data.date).format('YYYYMM'));
    return authKey
      ? gqlMongoDoc<TAppMealClaimSet>(this.dss, 'MealClaims', { 'auth._id': authKey, 'meta.yyyymm': yyyymm })
      : of<null>(null);
  };

  getNavinetClaims$ = (auth: INavinetAuthDoc) => {
    const aggregate = [
      {
        $match: {
          _mci: oc(auth)._mci(),
          SVCStartDT: { $lte: { $date: { v: oc(auth).EndDT() } } },
          SVCEndDT: { $gte: { $date: { v: oc(auth).StartDT() } } },
        },
      },
      {
        $project: {
          _source: 0,
        },
      },
      {
        $sort: { ClaimID: 1 },
      },
    ];

    return auth ? gqlMongoLoad(this.dss, 'Navinet_KFCHC_ClaimStatusImports', {}, aggregate) : of<[]>([]);
  };

  // getE9yDoc$ = (claimSet: TAppMealClaimSet) => {
  //   let e9yDocs: IStediE9yDoc[];
  //
  //   e9yDocs = [
  //     ...oc(claimSet)
  //       .e9ies([])
  //       .map(e => e.e9y),
  //     // ...oc(this.data).member.e9y([]),
  //   ];
  //
  //   if (e9yDocs.length > 0) {
  //     e9yDocs = e9yDocs.filter(doc => oc(doc).status.active());
  //
  //     const e9yDoc = oc(this.lastClaim).request()
  //       ? e9yDocs.find(d => d.e9y === oc(this.lastClaim).request.tradingPartnerServiceId())
  //       : e9yDocs.find(
  //           d =>
  //             oc(d).response.tradingPartnerServiceId('') === '6751' &&
  //             (oc(d).response.payer.name('').includes('ALIGNED') || oc(d).response.payer.name('').includes('VIP')),
  //         ) ||
  //         e9yDocs.find(
  //           d =>
  //             oc(d).response.tradingPartnerServiceId('') === '8121' &&
  //             !oc(d).response.payer.name('').includes('ALIGNED') &&
  //             !oc(d).response.payer.name('').includes('VIP'),
  //         ) ||
  //         e9yDocs[0];
  //
  //     const key = oc(e9yDoc)._id();
  //     return key ? gqlMongoByKey<IStediE9yDoc>(this.dss, 'StediEligibilityDataCache', key) : of<null>(null);
  //   } else {
  //     const [e9yId] = oc(this.data)
  //       .member.e9y([])
  //       .map(d => d._id);
  //
  //     return e9yId ? gqlMongoByKey<IStediE9yDoc>(this.dss, 'StediEligibilityDataCache', e9yId) : of<null>(null);
  //   }
  // };

  onFieldDataChanged(e) {
    // console.log(e);

    if (['service.unitCount', 'rate'].includes(e.dataField)) {
      const amount = +(oc(this.form.formData).rate(0) * oc(this.form.formData).service.unitCount(0)).toFixed(2);

      this.form.instance.updateData('service.chargeAmount', amount);
      this.form.instance.updateData('chargeAmount', amount);
    }
  }

  submit() {
    // console.log(this.form.formData);

    this.ui.showLoading();
    void this.api
      .submitClaim(this.form.formData, this.correctionType, this.isTest ? 'T' : 'P')
      .pipe(
        map(({ claimSetId }) => claimSetId),
        tap(() => notify('Claim has been processed', 'success', 5000)),
        tap(claimId => this.dialogRef.close(claimId)),
        catchError(err => of(notify(err.message, 'error', 10_000))),
      )
      .toPromise()
      .finally(() => this.ui.hideLoading());
  }
}
